import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { getEncuestas, setFormulario } from "../actions";

import { Container, Row, Col } from "react-bootstrap";

import GraficoPregunta from "./GraficoPregunta";

const Equipo = (props) => {
  const dispatch = useDispatch();

  const [values, setValues] = useState({});

  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = (event) => {
    event.persist();
    setValues((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    //console.log("values", values);

    const _params = {
      Token: "c3649ba4e3a81815",
      Function: "GetCmdicEncuestaLista",
      Parameters: {
        identificador: "0",
        id_equipo: 11,
      },
    };
    dispatch(getEncuestas(_params));
    dispatch(setFormulario({ campo: "filtroIniciativa", valor: values }));
  };
  //console.log("componente", props);

  return (
    <Container>
      <Row></Row>
      <Row>
        <Col>
          <h1>Reportes</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          {" "}
          <hr />
          <h2>Cantidad de Derivaciones</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <GraficoPregunta
            datos={[100, 72, 95, 52]}
            etiquetas={["1T", "2T", "3T", "4T"]}
          ></GraficoPregunta>
        </Col>
        <Col>
          <GraficoPregunta
            datos={[35, 19, 46, 20, 47, 5, 5, 55, 35, 18, 32, 2]}
            etiquetas={[
              "Ene",
              "Feb",
              "Mar",
              "Abr",
              "May",
              "Jun",
              "Jul",
              "Ago",
              "Sep",
              "Oct",
              "Nov",
              "Dic",
            ]}
          ></GraficoPregunta>
        </Col>
      </Row>
      <Row>
        <Col>
          {" "}
          <hr />
          <h2>Respondido el mismo día</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <GraficoPregunta
            datos={[17, 22, 20, 25]}
            etiquetas={["1T", "2T", "3T", "4T"]}
          ></GraficoPregunta>
        </Col>
        <Col>
          <GraficoPregunta
            datos={[6, 1, 10, 5, 13, 4, 1, 10, 9, 4, 21, 0]}
            etiquetas={[
              "Ene",
              "Feb",
              "Mar",
              "Abr",
              "May",
              "Jun",
              "Jul",
              "Ago",
              "Sep",
              "Oct",
              "Nov",
              "Dic",
            ]}
          ></GraficoPregunta>
        </Col>
      </Row>
      <Row>
        <Col>
          {" "}
          <hr />
          <h2>Tiempo Máximo en Responder</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <GraficoPregunta
            datos={[256, 176, 114, 46]}
            etiquetas={["1T", "2T", "3T", "4T"]}
          ></GraficoPregunta>
        </Col>
        <Col>
          <GraficoPregunta
            datos={[247, 256, 239, 46, 176, 133, 114, 90, 70, 46, 19, 12]}
            etiquetas={[
              "Ene",
              "Feb",
              "Mar",
              "Abr",
              "May",
              "Jun",
              "Jul",
              "Ago",
              "Sep",
              "Oct",
              "Nov",
              "Dic",
            ]}
          ></GraficoPregunta>
        </Col>
      </Row>
      <Row>
        <Col>
          {" "}
          <hr />
          <h2>Derivaciones por Dirección</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <GraficoPregunta
            datos={[
              3, 3, 9, 4, 16, 3, 1, 3, 13, 1, 48, 2, 36, 3, 30, 37, 2, 11, 3, 2,
              71, 9, 4, 5,
            ]}
            etiquetas={[
              "CAM",
              "CAF",
              "CCSL",
              "DEPORTES",
              "DOM",
              "TRANSITO",
              "JURIDICO",
              "EDUC",
              "ESPACIO PUBLICO",
              "GDP",
              "VIVIENDA",
              "DESARROLLO ECONOMICO",
              "INSPECCION",
              "MEDIO AMBIENTE",
              "RENTAS",
              "SALUD",
              "SECMUN",
              "SEGURIDAD",
              "SERV COMUN- DISC",
              "SERV COMUN - PEÑA ALTO",
              "SERV SOCIALES",
              "YUNUS EMPRENDE",
              "YUNUS INCLUSION",
              "YUNUS OMIL",
            ]}
          ></GraficoPregunta>
        </Col>
      </Row>
    </Container>
  );
};

export default Equipo;
